var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2446 9.54066V13.541C16.2446 15.4331 14.7309 17.0008 12.7848 17.0008H4.45976C2.51364 17.0008 1 15.4331 1 13.541V5.16191C1 3.26985 2.51364 1.70215 4.4057 1.70215H8.56822",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5389 3.48707L9.10502 9.921C8.83468 10.1913 8.34808 10.1913 8.07775 9.921C7.80742 9.65066 7.80742 9.16406 8.07775 8.89373L14.5657 2.40573H11.6461C11.2677 2.40573 10.9433 2.08133 10.9433 1.70287C10.9433 1.3244 11.2677 1 11.6461 1H16.2418C16.6743 1 16.9987 1.3244 16.9987 1.70287V6.3526C16.9987 6.73106 16.6743 7.05546 16.2418 7.05546C15.8633 7.05546 15.5389 6.73106 15.5389 6.3526V3.48707Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.2bb1c388ccb622d7d2597e9937c18479.svg";
export { ForwardRef as ReactComponent };